var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAndroidIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "104870_android_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.74359 8.1767V17.5302H5.74893C5.81451 18.3204 6.54126 18.9481 7.4212 18.9481H16.8266C17.7065 18.9481 18.4332 18.3204 18.4989 17.5302H18.5043V8.1767H5.74359Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.25685 15.0274C5.25685 15.95 4.6141 16.705 3.82857 16.705C3.0429 16.705 2.40005 15.95 2.40005 15.0274V9.53697C2.40005 8.61419 3.04285 7.85931 3.82857 7.85931C4.6141 7.85931 5.25685 8.61419 5.25685 9.53697V15.0274Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.2104 21.8414C11.2104 22.7641 10.5675 23.5191 9.78192 23.5191C8.99639 23.5191 8.35364 22.7641 8.35364 21.8414V16.351C8.35364 15.4283 8.99639 14.6734 9.78192 14.6734C10.5675 14.6734 11.2104 15.4283 11.2104 16.351V21.8414Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.9719 21.8414C15.9719 22.7641 15.329 23.5191 14.5434 23.5191C13.7578 23.5191 13.1149 22.7641 13.1149 21.8414V16.351C13.1149 15.4283 13.7578 14.6734 14.5434 14.6734C15.329 14.6734 15.9719 15.4283 15.9719 16.351V21.8414Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M21.9112 15.0274C21.9112 15.95 21.2684 16.705 20.4828 16.705C19.6973 16.705 19.0544 15.95 19.0544 15.0274V9.53697C19.0544 8.61419 19.6973 7.85931 20.4828 7.85931C21.2684 7.85931 21.9112 8.61419 21.9112 9.53697V15.0274Z",
    fill: "#4FC0CF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M15.2787 2.55204L16.1953 0.907519C16.27 0.773175 16.248 0.616847 16.1463 0.560082C16.0444 0.503363 15.8998 0.566879 15.825 0.701175L14.8872 2.3838C14.0512 2.05483 13.1139 1.87043 12.124 1.87043C11.1266 1.87043 10.1828 2.05764 9.34176 2.39139L8.39981 0.701175C8.325 0.566832 8.18039 0.503363 8.07867 0.560082C7.97681 0.6168 7.95487 0.773175 8.02969 0.907519L8.95073 2.56033C7.03448 3.46028 5.74359 5.15032 5.74359 7.08691C5.74359 7.28369 5.75742 7.47775 5.78325 7.66882H18.4645C18.4905 7.47775 18.5043 7.28374 18.5043 7.08691C18.5043 5.14422 17.2051 3.44978 15.2787 2.55204ZM9.22842 5.42252C8.92022 5.42252 8.67042 5.17272 8.67042 4.86452C8.67042 4.55636 8.92022 4.30647 9.22842 4.30647C9.53658 4.30647 9.78647 4.55636 9.78647 4.86452C9.78647 5.17277 9.53658 5.42252 9.22842 5.42252ZM15.0511 5.42252C14.7428 5.42252 14.493 5.17272 14.493 4.86452C14.493 4.55636 14.7428 4.30647 15.0511 4.30647C15.3592 4.30647 15.6091 4.55636 15.6091 4.86452C15.6091 5.17277 15.3592 5.42252 15.0511 5.42252Z",
    fill: "#4FC0CF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIcon);
export default __webpack_public_path__ + "static/media/android_icon.925ff7aab8628097a2a50171e81f5957.svg";
export { ForwardRef as ReactComponent };